export default __webpack_public_path__ + "static/media/rocket.69d8c3a4.png";